/**
 * Type de finances
 */
export enum FinanceType {
    // Pour la page tableau de bord budgétaire
    BASHBOARD,
    // POur la page admission en non-valeur
    ADMISSION,
    // Pour la page créances éteintes
    DEBT,
    // Pour la liste des impayés
    UNPAID,
}
